<template>
  <div>
    <div class="item-header item-header-no-border-bottom clearfix mb-3">
      <h5 class="pull-left mb-0 mt-2">Assigned Prestart Checklist</h5>
      <div class="pull-right">
        <b-button
          v-if="!visibleAssign"
          @click="visibleAssign = !visibleAssign"
          variant="outline-primary">
          <i class="fa fa-plus"></i>&nbsp; Add
        </b-button>
        <b-button
          title="Copy this assigned prestart to other vehicles"
          @click="visibleCollapseCopy = !visibleCollapseCopy"
          v-if="hasPrestarts && !visibleCollapseCopy"
          variant="outline-primary">
          <i class="fa fa-copy"></i>&nbsp; Copy
        </b-button>
      </div>
    </div>
    <b-collapse id="assign-collapse" v-model="visibleAssign" class="mt-2">
      <b-card>
        <div class="row">
          <div class="col-md-12">
            <b-form-group label="Available Prestart Checklist">
              <b-form-checkbox-group
                v-model="selectedPrestart"
                :options="optionsPrestart"
                name="flavour-2a"
                stacked
              ></b-form-checkbox-group>
            </b-form-group>
          </div>
        </div>
        <hr>
        <b-button
          @click="onAssign()"
          :disabled="selectedPrestart.length === 0"
          variant="primary">Submit</b-button>
        <b-button
          @click="visibleAssign = !visibleAssign"
          variant="outline-secondary"
          class="pull-right">Cancel</b-button>
      </b-card>
    </b-collapse>
    <b-collapse id="copy-collapse" v-model="visibleCollapseCopy" class="mt-2">
      <b-card>
        <div class="row">
          <div class="col-md-12">
            <h6>
              <strong>Copy to vehicles</strong>
              <a
                ref="select_all"
                @click.prevent="isSelectAllVehicle = !isSelectAllVehicle"
                class="pull-right" href="#">Select All</a>
            </h6>
            <b-form-input
              @input="onSearchVehicle"
              class="mt-2 mb-2"
              type="text" placeholder="Search vehicle"></b-form-input>
            <div id="vehicle-list-container">
              <b-form-group>
                <b-form-checkbox-group
                  v-model="selectedVehicles"
                  :options="optionsVehicles"
                  name="flavour-2a"
                  stacked
                ></b-form-checkbox-group>
              </b-form-group>
            </div>
          </div>
        </div>
        <hr>
        <b-button
          @click="onSubmitCopy()"
          :disabled="selectedVehicles.length === 0"
          variant="primary">Submit</b-button>
        <b-button
          @click="visibleCollapseCopy = !visibleCollapseCopy"
          variant="outline-secondary"
          class="pull-right">Cancel</b-button>
      </b-card>
    </b-collapse>
    <b-table striped responsive :fields="table.fields" :items="table.items">
      <template #cell(type)="data">
        <span v-if="data.item.type === 'THREE_CHOICES'">
          <i class="fa fa-commenting" aria-hidden="true"></i> Three Choices
        </span>
        <span v-else-if="data.item.type === 'FILL'">
          <i class="fa fa-pencil" aria-hidden="true"></i> Fill
        </span>
        <span v-else-if="data.item.type === 'MULTI_CHOICE'">
          <i class="fa fa-check-square" aria-hidden="true"></i> Multi Choices
        </span>
        <span v-else-if="data.item.type === 'CHOICE'">
          <i class="fa fa-dot-circle-o" aria-hidden="true"></i> Choice
        </span>
      </template>
      <template #cell(action)="data">
        <b-button :title="`Remove this question from ${detailedInfo.reg_no}`" @click="removeAssign(data.item)" variant="outline-danger">Remove</b-button>
      </template>
    </b-table>
  </div>
</template>

<script>
import { isEmpty, orderBy, debounce, trim } from 'lodash';

export default {
  name: 'prestart_checklist_vehicle',
  data() {
    return {
      visibleAssign: false,
      visibleCollapseCopy: false,
      isSelectAllVehicle: false,
      selectedPrestart: [],
      optionsPrestart: [],
      selectedVehicles: [],
      optionsVehicles: [],
      table: {
        fields: ['name', 'type', 'question', 'action'],
        items: [],
      },
    };
  },
  created() {
    const { vehicleId } = this.$route.params;
    this.loadData();
    this.$store.commit('vehicles/SET_DETAIL_ID', vehicleId);
    this.$store.dispatch('vehicles/LOAD_DETAIL_DATA').then(() => {
      this.$store.dispatch('prestart_checklist/LOAD_DATA_BY_COMPANY', {
        company_id: this.detailedInfo.company.id,
      }).then((data) => {
        this.optionsPrestart = data.map(dt => ({ text: dt.name, value: dt.id }));
      });
    });
    this.$store.dispatch('vehicles/LOAD_INFO').then(() => {
      this.$store.commit('vehicles/SET_QUERY_COUNT', this.countAllVehicle);
      this.$store.dispatch('vehicles/LOAD_DATA');
    });
  },
  computed: {
    detailedInfo() {
      const detailInfo = this.$store.getters['vehicles/get_detail_data'];
      return detailInfo;
    },
    hasPrestarts() {
      return !isEmpty(this.table.items);
    },
    countAllVehicle() {
      return this.$store.getters['vehicles/count_all'];
    },
    vehicles() {
      const vehicles = this.$store.getters['vehicles/vehicles'];
      return vehicles;
    },
  },
  watch: {
    vehicles(data) {
      let setOptions = data
        .filter(dt => dt.id !== this.detailedInfo.id)
        .map(dt => ({ text: dt.reg_no, value: dt.id }));
      setOptions = orderBy(setOptions, ['text'], ['asc']);
      this.optionsVehicles = setOptions;
    },
    isSelectAllVehicle(selectAll) {
      if (selectAll) {
        this.$refs.select_all.innerHTML = 'Unselect All';
        this.selectedVehicles = this.optionsVehicles
          .filter(dt => dt.value !== this.detailedInfo.id)
          .map(dt => dt.value);
      } else {
        this.$refs.select_all.innerHTML = 'Select All';
        this.selectedVehicles = [];
      }
    },
  },
  methods: {
    loadData() {
      const { vehicleId } = this.$route.params;
      this.$store.dispatch('prestart_checklist/LOAD_PRESTART_VEHICLE', {
        vehicle_id: vehicleId,
      }).then((data) => {
        this.selectedPrestart = data.map(dt => (dt.id));
        this.table.items = data;
      });
    },
    onAssign() {
      const { vehicleId } = this.$route.params;
      const prestartIds = this.selectedPrestart.map(id => Number(id));
      this.$store.dispatch('prestart_checklist/ASSIGN_PRESTART_VEHICLE', {
        vehicle_id: vehicleId,
        prestart_checklist_ids: prestartIds,
      }).then((result) => {
        if (result) {
          this.$swal('Success', 'Prestarts success assigned to vehicle', 'success').then(() => {
            this.loadData();
            this.visibleAssign = false;
          });
        } else {
          this.$swal('Failed', 'Failed assign prestart', 'error');
        }
      });
    },
    removeAssign(data) {
      this.$swal({
        title: 'Are you sure',
        text: `Want to remove this question from ${this.detailedInfo.reg_no}?`,
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes Remove it!',
        cancelButtonText: 'No, Keep it!',
        showCloseButton: true,
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch('prestart_checklist/REMOVE_ASSIGN_PRESTART', {
            vehicle_id: this.detailedInfo.id,
            prestart_checklist_id: data.id,
          }).then((ok) => {
            if (ok) {
              this.$swal('Removed', 'You successfully removed this question', 'success').then(() => {
                this.loadData();
              });
            } else {
              this.$swal('Failed', 'Failed to remove prestart', 'error');
            }
          });
        }
      });
    },
    onSubmitCopy() {
      const payloads = {
        vehicle_id: this.detailedInfo.id,
        vehicles_target: this.selectedVehicles,
      };
      this.$store.dispatch('prestart_checklist/COPY_ASSIGNED_PRESTART', payloads).then((ok) => {
        if (ok) {
          this.$swal('Copied', 'You successfully copied this assigned prestart', 'success').then(() => {
            this.visibleCollapseCopy = !this.visibleCollapseCopy;
          });
        } else {
          this.$swal('Failed', 'Failed to copy assigned prestart', 'error');
        }
      });
    },
    onSearchVehicle: debounce(function onSearchVehicle(value) {
      const searchVal = trim(value);
      let allVehicles = this.vehicles
        .filter(dt => dt.id !== this.detailedInfo.id)
        .map(dt => ({ text: dt.reg_no, value: dt.id }));
      allVehicles = orderBy(allVehicles, ['text'], ['asc']);

      if (!isEmpty(searchVal)) {
        this.optionsVehicles = allVehicles
          .filter(dt => dt.text.toLocaleLowerCase().indexOf(searchVal.toLocaleLowerCase()) > -1);
      } else {
        this.optionsVehicles = allVehicles;
      }
    }, 1e3),
  },
};
</script>
<style>
  #vehicle-list-container {
    max-height: 300px;
    overflow-x: auto;
  }
  .item-header-no-border-bottom {
    border-bottom: unset;
  }
</style>



// WEBPACK FOOTER //
// src/views/pages/admin/vehicles/detail/PrestartChecklistVehicle.vue